// Independent in-browser verifier: same algorithm as backend/game_engine.py (bkm-v1).
const enc = new TextEncoder();

const toHex = (buf) => Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");

export const sha256Hex = async (s) => toHex(await crypto.subtle.digest("SHA-256", enc.encode(s)));

const hmacKey = (seed) => crypto.subtle.importKey("raw", enc.encode(seed), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);

async function uniformInt(key, label, n) {
  const limit = 256 - (256 % n);
  for (let nonce = 0; ; nonce += 1) {
    const d = new Uint8Array(await crypto.subtle.sign("HMAC", key, enc.encode(`${label}:${nonce}`)));
    for (const b of d) if (b < limit) return b % n;
  }
}

const sortPy = (arr) => [...arr].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));

async function drawOrder(key, gameId, ids) {
  const order = sortPy(ids);
  for (let i = order.length - 1; i > 0; i -= 1) {
    const j = await uniformInt(key, `${gameId}:order:${i}`, i + 1);
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
}

export async function replayGame({ seed, gameId, playerIds, diceCount = 2, maxRerolls = 3 }) {
  const key = await hmacKey(seed);
  const order = await drawOrder(key, gameId, playerIds);
  const rounds = [];
  let contenders = order;
  for (let r = 0; ; r += 1) {
    const results = [];
    for (const p of contenders) {
      const dice = [];
      for (let i = 0; i < diceCount; i += 1) dice.push(1 + (await uniformInt(key, `${gameId}:roll:${r}:${p}:${i}`, 6)));
      results.push({ player_id: p, dice, total: dice.reduce((a, b) => a + b, 0) });
    }
    const best = Math.max(...results.map((x) => x.total));
    const leaders = results.filter((x) => x.total === best).map((x) => x.player_id);
    rounds.push({ round: r, results, best, leaders });
    if (leaders.length === 1 || r >= maxRerolls) return { seed_hash: await sha256Hex(seed), order, rounds, winners: leaders };
    contenders = leaders;
  }
}
